import { Text, Field, Item, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';

import styles from './FAQ.module.scss';

const cx = classNames.bind(styles);

type FaqItemFields = {
  body: Field<string>;
  idAttribute: Field<string>;
  title: Field<string>;
};

export type FaqItemProps = Item & {
  fields: FaqItemFields;
  headingLevel: string;
  headingStyle: string;
  id: string;
};

const FaqItem = (props: FaqItemProps): JSX.Element => {
  const { fields, headingLevel, headingStyle } = props;
  const { body, idAttribute, title } = fields;
  const { sitecoreContext } = useSitecoreContext();

  return (
    <div className={cx('q-and-a')} id={idAttribute?.value}>
      <Text
        className={(cx('q-and-a__question'), cx(headingStyle))}
        field={title}
        tag={headingLevel}
        encode={sitecoreContext.pageEditing}
      />
      <RichTextWrapper className={cx('q-and-a__answer')} field={body} tag="div" />
    </div>
  );
};

export default FaqItem;
